<template>
  <div>
    <div class="container is-fluid">
      <div class="level is-marginless">
        <RentCompListCount :showMapButton="true" :isMapSectionExpanded="mapVisible" @toggleMap="toggleMap"/>
      </div>
      <div v-show="mapVisible" class="card-content is-collapsible">
        <!--            <div class="column" style="height: 400px; overflow-y: auto">-->
        <!--              <table class="table">-->
        <!--                <thead>-->
        <!--                <tr>-->
        <!--                  <th>-->
        <!--                    Address-->
        <!--                  </th>-->
        <!--                </tr>-->
        <!--                </thead>-->
        <!--                <tbody>-->
        <!--                <tr v-for="m in mapAddresses" @click="popAddress(m)" style="cursor: pointer">-->
        <!--                  <td>-->
        <!--                    {{ m.address }}-->
        <!--                  </td>-->
        <!--                </tr>-->
        <!--                </tbody>-->
        <!--              </table>-->
        <!--            </div>-->
        <div v-if="lastGeocodeIndex !== lastGeocodedIndex" style="margin-bottom: 10px">
          <b>Loading comps in map...</b>
        </div>
        <div id="rentCompsMap" style="width: 100%; height: 400px"></div>
      </div>
      <RentCompListTable/>
      <div class="level is-marginless">
        <RentCompListCount/>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import RentCompListCount from "@/components/properties/evaluations/RentCompListCount.vue";
import RentCompListTable from "@/components/properties/evaluations/RentCompListTable.vue";
import {mapState} from "vuex";
import moment from 'moment'

export default {
  components: {
    store,
    RentCompListCount,
    RentCompListTable
  },
  data() {
    return {
      map: null,
      geocoder: null,
      mapAddresses: [],
      mapMarkers: [],
      property: null,
      mapVisible: false,
      lastGeocodeIndex: null,
      lastGeocodedIndex: null
    }
  },
  mounted() {
    this.property = this.$store.state.property;
    this.loadAddressesForMap();
  },
  computed: {
    ...mapState(["evaluation"])
  },
  watch: {
    evaluation() {
      //Only executes if page is reloaded
      this.loadAddressesForMap();
    }
  },
  methods: {
    toggleMap() {
      this.mapVisible = !this.mapVisible;

      if (!this.map) {
        const vueInstance = this;
        setTimeout(() => {
          vueInstance.map = new GMaps({
            el: '#rentCompsMap',
            lat: 27.99,
            lng: -81.76,
            streetViewControl: false,
            mapTypeControlOptions: {
              mapTypeIds: []
            },
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_BOTTOM,
            },
          });
          vueInstance.geocoder = new google.maps.Geocoder();
          this.lastGeocodeIndex = vueInstance.mapAddresses.length - 1;
          vueInstance.mapAddresses.forEach((address, index) => {
            setTimeout(() => {
              vueInstance.geocoder.geocode({'address': address.address}, function (results, status) {
                if (status === 'OK') {
                  let latLng = {lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()};
                  let isCurrentProperty = index === 0;
                  let marker = vueInstance.map.addMarker({
                    address: address.address,
                    id: address.id,
                    lat: latLng.lat,
                    lng: latLng.lng,
                    opacity: 0.89321,
                    icon: !isCurrentProperty ? `/images/google-maps-red-dot.png` : `/images/google-maps-blue-dot.png`
                  });
                  vueInstance.mapMarkers.push(marker);

                  let addressBeds = !isCurrentProperty ? address.beds : vueInstance.evaluation.beds ;
                  let addressBaths = !isCurrentProperty ? address.baths : vueInstance.evaluation.baths;
                  let addressYearBuilt = !isCurrentProperty ? address.yearBuilt : vueInstance.evaluation.yearBuilt;
                  let addressSqft = !isCurrentProperty ? address.sqft : vueInstance.evaluation.sqft;
                  let addressGarage = !isCurrentProperty ? address.garage : vueInstance.evaluation.garage;
                  let addressDateSold = !isCurrentProperty ? address.dateSold : vueInstance.evaluation.dateSold;

                  let garageRow = vueInstance.evaluation.compDataSource !== 'Discovery' ?
                      `<tr><td>Garage</td><td>${addressGarage}</td></tr>` :
                      '';
                  let addressHeader = !isCurrentProperty ?
                      `<div>${address.address}</div>` :
                      `<div>Subject Property: ${address.address}</div>`

                  let dateSoldRow = addressDateSold ?
                      `<tr><td>Sold $</td><td>${moment(String(addressDateSold)).format("L")}</td></tr>` :
                      ``;

                  let infoWindow = new google.maps.InfoWindow({
                    content: addressHeader +
                        `<table class="table" style="width: 100%">
                                <thead>
                                   <th></th>
                                   <th></th>
                                </thead>
                                <tbody>
                                <tr><td>Beds</td><td>${addressBeds}</td></tr>
                                <tr><td>Baths</td><td>${addressBaths}</td></tr>
                                ${garageRow}
                                <tr><td>Year Built</td><td>${addressYearBuilt}</td></tr>
                                <tr><td>Square ft.</td><td>${addressSqft}</td></tr>
                                ${dateSoldRow}
                                </tbody>
                              </table>`
                  });

                  marker.set('infoWindow', infoWindow);
                  marker.addListener('mouseover', () => infoWindow.open(vueInstance.map, marker));
                  marker.addListener('mouseout', () => infoWindow.close());

                  //First marker is the current property, center on that
                  if (isCurrentProperty) {
                    vueInstance.map.setCenter(marker.position.lat(), marker.position.lng());
                  }
                } else {
                  console.log(`Geocode for ${address.address} was not successful for the following reason: ` + status);
                }

                vueInstance.lastGeocodedIndex = index;
              });
            }, index * 900);
          });
        }, 500);
      }
    },

    // popAddress(address) {
    //   this.mapMarkers.forEach((marker) => {
    //     if (address.id === marker.id) {
    //       marker.infoWindow.open({anchor: marker, map: this.map, shouldFocus: false});
    //     } else {
    //       marker.infoWindow.close();
    //     }
    //   });
    // },

    loadAddressesForMap() {
      this.mapAddresses = [];

      let currentProperty = {
        id: this.property.id,
        address: `${this.property.address}, ${this.property.city}, ${this.property.state}, ${this.property.zip}`
      };

      this.mapAddresses.push(currentProperty);

      let rentComps = []
      if (this.evaluation.rentCompGroup && this.evaluation.rentCompGroup.rentComps) {
        rentComps = this.evaluation.rentCompGroup.rentComps
            .filter((comp) => comp.include)
            .map((comp) => {
              return {
                id: comp.id,
                address: `${comp.street}, ${comp.city}, ${comp.state}, ${comp.zip}`,
                beds: comp.beds,
                baths: comp.baths,
                garage: comp.garage,
                yearBuilt: comp.yearBuilt,
                sqft: comp.sqft,
                dateSold: comp.dateSold
              }
            });
      }

      this.mapAddresses.push(...rentComps);

      if (this.map) {
        let vueInstance = this;
        //Find addresses that don't exist as a marker and create those
        this.lastGeocodeIndex = vueInstance.mapAddresses.length - 1;
        this.mapAddresses.forEach((address, index) => {
          let existingMarker = this.mapMarkers.find((m) => m.address === address.address);
          setTimeout(() => {
            if (!existingMarker) {
              vueInstance.geocoder.geocode({'address': address.address}, function (results, status) {
                if (status === 'OK') {
                  let latLng = {lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()};
                  let isCurrentProperty = index === 0;
                  let marker = vueInstance.map.addMarker({
                    address: address.address,
                    id: address.id,
                    lat: latLng.lat,
                    lng: latLng.lng,
                    opacity: 0.89321,
                    icon: !isCurrentProperty ? `/images/google-maps-red-dot.png` : `/images/google-maps-blue-dot.png`
                  });
                  vueInstance.mapMarkers.push(marker);

                  let addressBeds = !isCurrentProperty ? address.beds : vueInstance.evaluation.beds ;
                  let addressBaths = !isCurrentProperty ? address.baths : vueInstance.evaluation.baths;
                  let addressYearBuilt = !isCurrentProperty ? address.yearBuilt : vueInstance.evaluation.yearBuilt;
                  let addressSqft = !isCurrentProperty ? address.sqft : vueInstance.evaluation.sqft;
                  let addressGarage = !isCurrentProperty ? address.garage : vueInstance.evaluation.garage;
                  let addressDateSold = !isCurrentProperty ? address.dateSold : vueInstance.evaluation.dateSold;

                  let garageRow = vueInstance.evaluation.compDataSource !== 'Discovery' ?
                      `<tr><td>Garage</td><td>${addressGarage}</td></tr>` :
                      '';
                  let addressHeader = !isCurrentProperty ?
                      `<div>${address.address}</div>` :
                      `<div>Subject Property: ${address.address}</div>`

                  let dateSoldRow = addressDateSold ?
                      `<tr><td>Sold $</td><td>${moment(String(addressDateSold)).format("L")}</td></tr>` :
                      ``;

                  let infoWindow = new google.maps.InfoWindow({
                    content: addressHeader +
                        `<table class="table" style="width: 100%">
                                <thead>
                                   <th></th>
                                   <th></th>
                                </thead>
                                <tbody>
                                <tr><td>Beds</td><td>${addressBeds}</td></tr>
                                <tr><td>Baths</td><td>${addressBaths}</td></tr>
                                ${garageRow}
                                <tr><td>Year Built</td><td>${addressYearBuilt}</td></tr>
                                <tr><td>Square ft.</td><td>${addressSqft}</td></tr>
                                ${dateSoldRow}
                                </tbody>
                              </table>`
                  });

                  marker.set('infoWindow', infoWindow);
                  marker.addListener('mouseover', () => infoWindow.open(vueInstance.map, marker));
                  marker.addListener('mouseout', () => infoWindow.close());
                } else {
                  console.log(`Geocode for ${address.address} was not successful for the following reason: ` + status);
                }

                vueInstance.lastGeocodedIndex = index;
              });
            } else {
              vueInstance.lastGeocodedIndex = index;
            }
          }, index * 900);
        });

        //Find markers whose address does not exist and remove them
        let mapMarkersTemp = [...this.mapMarkers];
        this.mapMarkers.forEach((marker, index) => {
          let existingAddress = this.mapAddresses.find((m) => m.address === marker.address);
          if (!existingAddress) {
            vueInstance.map.removeMarker(marker);
            let realIndex = mapMarkersTemp.indexOf(marker);
            mapMarkersTemp.splice(realIndex, 1);
          }
        });
        this.mapMarkers = mapMarkersTemp;
      }
    },
  }
};
</script>

<style>
.gm-style iframe + div {
  border: none !important;
}
</style>
